// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JBBzO","primary":"Button_primary__9MLUH","default":"Button_default__e3o5q","link":"Button_link__vM+72"};